import { Modal } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import styles from '../UploadConfigModal.module.scss'

export const UploadConfigHeader = () => {
    return (
        <Modal.Header
            closeButton
            className={styles.windowPadding}
        >
            <Modal.Title>
                <FormattedMessage id="modals.configs.uploadTitle" />
            </Modal.Title>
        </Modal.Header>
    )
}